import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { OrgSettingsComponent } from './org-settings.component';

export const ngxOrgSettingsModule = angular.module('ngxOrgSettingsModule', [])
	.directive('ngxOrgSettings', downgradeComponent({component: OrgSettingsComponent}))
	.name;
